var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0242 5.99707C12.2054 5.99715 12.3875 6.14701 12.3875 6.36035V11.6133H17.6404C17.7535 11.6134 17.8351 11.6718 17.8855 11.749C17.9341 11.8239 17.9548 11.9172 17.9548 12C17.9548 12.1813 17.805 12.3633 17.5916 12.3633H12.3386V17.5918C12.3386 17.6882 12.2918 17.7792 12.2273 17.8438C12.1628 17.9082 12.0725 17.955 11.9763 17.9551C11.795 17.9551 11.613 17.8052 11.613 17.5918V12.3389H6.36011C6.26381 12.3389 6.17364 12.292 6.10913 12.2275C6.04467 12.1631 5.99692 12.0728 5.99683 11.9766C5.99683 11.7952 6.1467 11.6133 6.36011 11.6133H11.6609V6.36035C11.6609 6.26396 11.7087 6.1739 11.7732 6.10938C11.8377 6.04486 11.9278 5.99707 12.0242 5.99707Z",
    fill: "currentColor",
    stroke: "white",
    strokeWidth: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.7c25e3f9f1da3c730936f5c82ff41376.svg";
export { ForwardRef as ReactComponent };